<template>
  <div v-loading="loading">
    <Form
      :model="formData"
      ref="form"
      :show-message="true"
      label-position="right"
      :label-width="120">
      <Row>
        <Col span="8">
          <FormItem :label="l('SHENGQINGREN')">{{item.applyUserName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('SHENGQINGSHIJIAN')">{{item.applyTime}}</FormItem>
        </Col>
      </Row>
      <Divider size="small" style="font-size:13px;">{{l("JIHUAXIANGQING")}}</Divider>
      <FormItem
        v-for="te in form"
        :key="te.fieldId"
        :label="getLabel(te)"
        :prop="te.fieldId"
        :rules="{required: te.required, message: l('BITIAN')}"
      >
        <Input v-if="te.type=='textbox'" v-model="formData[te.fieldId]" readonly></Input>
        <el-input
        disabled
          v-if="te.type=='numberbox'"
          type="number"
          size="small"
          v-model="formData[te.fieldId]"
          readonly
        ></el-input>
        <Select v-if="te.type=='select'" v-model="formData[te.fieldId]" readonly>
          <Option v-for="x in getItemOptions(te.options)" :key="x" :value="x">{{x}}</Option>
        </Select>
        <Checkbox
          v-if="te.type=='checkbox'"
          v-model="formData[te.fieldId]"
          :disabled="true"
        >&nbsp;{{te.name}}</Checkbox>
        <RadioGroup v-if="te.type=='radio'" v-model="formData[te.fieldId]" :disabled="true">
          <Radio disabled v-for="x in getItemOptions(te.options)" :key="x" :label="x">{{x}}</Radio>
        </RadioGroup>
        <div v-if="te.type=='upload'&& formData[te.fieldId]">
          <Button @click="download(formData[te.fieldId],te.name)">{{te.name}}{{l("XIAZAI")}}</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  name: "classRoomAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {},
      form: [],
      formData: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("user/trainProjectClass/actionPlanInfo", { id: id })
          .then(result => {
            this.item = result.item;
            this.form = JSON.parse(this.item.formJson);
            var formData = {};
            if (this.item.formData) {
              formData = JSON.parse(this.item.formData);
            } else {
              for (var i = 0; i < this.form.length; i++) {
                formData[form[i].fieldId] = "";
              }
            }
            this.formData = formData;
          })
          .finally(() => (this.loading = false));
      }
    },
    getLabel(item) {
      if (
        item.type == "numberbox" ||
        item.type == "textbox" ||
        item.type == "select" ||
        item.type == "radio" ||
        item.type == "checkbox"
      ) {
        return item.name;
      }
    },
    getItemOptions(options) {
      if (options) {
        return options.split(",");
      } else {
        return [];
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// trainClassActionPlanSubmit.vue?2786dae0